export default __webpack_public_path__ + "static/media/logo-black.55b75377.png";